$(document).ready(function() {
	$('.modal--link-size').click(function(e) {
		setTimeout(function() {
			$('.modal--content').removeClass('active');
			$('.modal--content-size').addClass('active active-modal');
		}, 100);
	});

	function drawThumbs() {
		var thumbUrls = null;
	    /*var thumbUrls = $('[data-thumb-url]').map(function() {
	        return $(this).attr('data-thumb-url');
	    }).get();*/
	    var thumbUrls = $('.product-page--root .carousel--y-container [data-thumb-url]').map(function() {
        	return $(this).attr('data-thumb-url');
    	}).get();


	    $('.product-page--root .carousel--dot-nav .carousel--dot').each(function(index) {
	        if (index < thumbUrls.length) {
	            $(this).html('<img src="' + thumbUrls[index] + '" />');
	        }
	    });
	}

	$('.radios--input').click(function(e) {
		setTimeout(function() {
			drawThumbs();
		}, 200);
	});




	setTimeout(function() {
		drawThumbs();
	}, 400);
});